<div style="display: flex; flex-direction: column; position: relative">
  <div #highlight class="highlight"></div>
  <div *ngFor="let outlineItem of outlineItems; let i = index"
       [ngClass]="outlineItemIndex === i ? 'item-selected' : 'item-not-selected'"
       [class]="'item-' + i"
       style="word-wrap: break-word">
    {{outlineItem}}
  </div>
</div>
